import React from 'react';
import { Tag, TagVariant } from '@estimateone/frontend-components';

export const NewTag: React.VFC = () => <Tag variant={TagVariant.Practical500} text="NEW" />;
